(() => {
  if (window.libertasProductBreadcrumb) {
    window.libertasProductBreadcrumb.init(document);
    return;
  }

  const STORAGE_KEY = 'libertas:product-origin:v1';
  const MAX_AGE = 30 * 24 * 60 * 60 * 1000;

  const normalizePath = (value) => {
    try {
      return decodeURIComponent(new URL(value, window.location.origin).pathname).replace(/\/+$/, '') || '/';
    } catch {
      return '';
    }
  };

  const normalizeProductPath = (value) => {
    const path = normalizePath(value);
    const productMatch = path.match(/\/products\/[^/]+$/);
    return productMatch ? productMatch[0] : path;
  };

  const safeRelativeUrl = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return '';
      return `${url.pathname}${url.search}${url.hash}`;
    } catch {
      return '';
    }
  };

  const isGenericCollectionUrl = (value) => (
    /\/collections\/all$/.test(normalizePath(value))
  );

  const getCollectionTrail = (origin) => {
    const collectionUrl = safeRelativeUrl(origin.dataset.collectionUrl);
    const collectionTitle = origin.dataset.collectionTitle?.trim();
    const breadcrumb = document.querySelector('[data-collection-breadcrumb]');
    const trail = [];

    if (breadcrumb) {
      const homeLink = breadcrumb.querySelector(':scope > a:first-child');

      [...breadcrumb.children].forEach((item) => {
        if (item === homeLink) return;

        const title = item.textContent?.trim();
        if (!title || title === '/') return;

        let url = '';
        if (item.matches('a[href]')) {
          url = safeRelativeUrl(item.href);
        } else if (item.hasAttribute('data-breadcrumb-current')) {
          url = collectionUrl;
        }

        trail.push({ title, url });
      });
    }

    if (trail.length === 0 && collectionTitle) {
      trail.push({ title: collectionTitle, url: collectionUrl });
    }

    return trail.filter((item, index, items) => (
      item.title
      && items.findIndex((candidate) => candidate.title === item.title && candidate.url === item.url) === index
    ));
  };

  const saveProductOrigin = (link) => {
    const origin = link.closest('[data-product-origin]');
    const productPath = normalizeProductPath(link.dataset.productPath || link.href);
    if (!origin || !productPath) return;

    if (isGenericCollectionUrl(origin.dataset.collectionUrl)) return;

    const trail = getCollectionTrail(origin);
    if (trail.length === 0) return;

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        productPath,
        trail,
        savedAt: Date.now(),
      }));
    } catch {
      // Browsing must continue if storage is unavailable.
    }
  };

  const readProductOrigin = (productPath) => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      if (
        !stored
        || normalizeProductPath(stored.productPath) !== productPath
        || !Array.isArray(stored.trail)
        || Date.now() - Number(stored.savedAt || 0) > MAX_AGE
      ) {
        return [];
      }

      return stored.trail
        .map((item) => ({
          title: typeof item.title === 'string' ? item.title.trim() : '',
          url: safeRelativeUrl(item.url),
        }))
        .filter((item) => item.title && !isGenericCollectionUrl(item.url));
    } catch {
      return [];
    }
  };

  const renderProductOrigin = (breadcrumb, trail) => {
    const origin = breadcrumb.querySelector('[data-product-breadcrumb-origin]');
    if (!origin || trail.length === 0) return;

    origin.replaceChildren();

    trail.forEach((item) => {
      const separator = document.createElement('span');
      separator.textContent = '/';
      origin.append(separator);

      const node = document.createElement(item.url ? 'a' : 'span');
      node.textContent = item.title;
      if (item.url) node.href = item.url;
      origin.append(node);
    });
  };

  const initProductBreadcrumb = (root = document) => {
    root.querySelectorAll('[data-product-breadcrumb]').forEach((breadcrumb) => {
      if (breadcrumb.dataset.productBreadcrumbStatic === 'true') return;
      if (breadcrumb.dataset.productBreadcrumbContext === 'true') return;

      const productPath = normalizeProductPath(breadcrumb.dataset.productPath);
      if (!productPath) return;

      renderProductOrigin(breadcrumb, readProductOrigin(productPath));
    });
  };

  window.libertasProductBreadcrumb = { init: initProductBreadcrumb };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-product-origin-link]');
    if (link) saveProductOrigin(link);
  }, true);

  initProductBreadcrumb();
  document.addEventListener('shopify:section:load', (event) => initProductBreadcrumb(event.target));
})();
